<template>
  <div data-component-group="filter-forms" data-component="package">
    <FiltersForm
      :has-filters="hasFilters"
      :is-global-country-filter="false"
      @filter="onFilter"
      @clear="onClearFilters"
    >
      <v-text-field
        clearable
        v-model="search"
        type="search"
        label="Search"
        prepend-inner-icon="search"
      />
    </FiltersForm>
  </div>
</template>

<script>
  import FiltersForm from './FiltersBase';
  import { escapeSearch } from '@/utils'

  // TODO: Translate component

  export default {
    components: {
      FiltersForm,
    },
    emits: ['clearFilters', 'filter'],
    data() {
      return {
        search: null,
      };
    },
    computed: {
      hasFilters() {
        const { search } = this;

        return !!search;
      },
    },
    methods: {
      onFilter() {
        const { search } = this;
        const formattedSearch = escapeSearch(search);

        this.$emit('filter', {
          search: formattedSearch,
        });
      },
      onClearFilters() {
        this.search = null;

        this.$emit('clearFilters');
      },
    },
  };
</script>
